import React, { useEffect } from "react";

export default function Toast({ msg, type, onDone }) {
  useEffect(() => { const t = setTimeout(onDone, 3000); return () => clearTimeout(t); }, [onDone]);
  return (
    <div style={{
      position: "fixed", bottom: 24, right: 24, zIndex: 500,
      background: type === "error" ? "#fee2e2" : "#dcfce7",
      color: type === "error" ? "#991b1b" : "#14532d",
      border: `1px solid ${type === "error" ? "#fca5a5" : "#86efac"}`,
      borderRadius: 10, padding: "12px 20px", fontWeight: 600, fontSize: 14,
      boxShadow: "0 4px 16px rgba(0,0,0,0.12)",
    }}>
      {msg}
    </div>
  );
}
